var S = Object.defineProperty;
var u = (e) => {
  throw TypeError(e);
};
var g = (e, s, t) => s in e ? S(e, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[s] = t;
var a = (e, s, t) => g(e, typeof s != "symbol" ? s + "" : s, t), d = (e, s, t) => s.has(e) || u("Cannot " + t);
var i = (e, s, t) => (d(e, s, "read from private field"), t ? t.call(e) : s.get(e)), h = (e, s, t) => s.has(e) ? u("Cannot add the same private member more than once") : s instanceof WeakSet ? s.add(e) : s.set(e, t), p = (e, s, t, n) => (d(e, s, "write to private field"), n ? n.call(e, t) : s.set(e, t), t);
import { g as f, h as m, a as l, p as y, j as L, c as x } from "./vidstack-8s6P_CC9.js";
import { VideoProvider as v } from "./vidstack-video-D76qkNcW.js";
const $ = "https://cdn.jsdelivr.net";
var c, r, o;
class j extends v {
  constructor() {
    super(...arguments);
    a(this, "$$PROVIDER_TYPE", "HLS");
    h(this, c, null);
    h(this, r, new f(this.video, this.ctx));
    h(this, o, `${$}/npm/hls.js@^1.5.0/dist/hls.min.js`);
  }
  /**
   * The `hls.js` constructor.
   */
  get ctor() {
    return i(this, c);
  }
  /**
   * The current `hls.js` instance.
   */
  get instance() {
    return i(this, r).instance;
  }
  get type() {
    return "hls";
  }
  get canLiveSync() {
    return !0;
  }
  /**
   * The `hls.js` configuration object.
   *
   * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#fine-tuning}
   */
  get config() {
    return i(this, r).config;
  }
  set config(t) {
    i(this, r).config = t;
  }
  /**
   * The `hls.js` constructor (supports dynamic imports) or a URL of where it can be found.
   *
   * @defaultValue `https://cdn.jsdelivr.net/npm/hls.js@^1.0.0/dist/hls.min.js`
   */
  get library() {
    return i(this, o);
  }
  set library(t) {
    p(this, o, t);
  }
  preconnect() {
    l(i(this, o)) && y(i(this, o));
  }
  setup() {
    super.setup(), new L(i(this, o), this.ctx, (t) => {
      p(this, c, t), i(this, r).setup(t), this.ctx.notify("provider-setup", this);
      const n = x(this.ctx.$state.source);
      n && this.loadSource(n);
    });
  }
  async loadSource(t, n) {
    if (!l(t.src)) {
      this.removeSource();
      return;
    }
    this.media.preload = n || "", this.appendSource(t, "application/x-mpegurl"), i(this, r).loadSource(t), this.currentSrc = t;
  }
  /**
   * The given callback is invoked when a new `hls.js` instance is created and right before it's
   * attached to media.
   */
  onInstance(t) {
    const n = i(this, r).instance;
    return n && t(n), i(this, r).onInstance(t);
  }
  destroy() {
    i(this, r).destroy();
  }
}
c = new WeakMap(), r = new WeakMap(), o = new WeakMap(), /**
 * Whether `hls.js` is supported in this environment.
 */
a(j, "supported", m());
export {
  j as HLSProvider
};
